import { style } from 'typestyle';
import { TabStyles } from '@tableau/widgets';

export const textFieldStyles = style({
  flexGrow: 1,
  $nest: {
    '& input': {
      width: '100%'
    }
  }
});

export const dialogBodyStyles: React.CSSProperties = {
  display: 'inline-block',
  // marginBottom: TabStyles.Spacing.LargeSpace,
  width: '100%'
};

export const groupNameFieldStyles: React.CSSProperties = {
  display: 'flex',
  marginBottom: TabStyles.Spacing.LargeSpace
};

export const siteRolePickerMenuStyles: React.CSSProperties = {
  width: '100%',
  marginTop: TabStyles.Spacing.SmallSpace,
};

export const outerCheckboxStyles: React.CSSProperties = {
  marginBottom: TabStyles.Spacing.LargeSpace
};
